import { useQuery } from "@tanstack/react-query";
import { dashApi } from "@/lib/dashApi";
import {
  ErrorState,
  GapList,
  Leaderboard,
  LoadingState,
  PageHeader,
  Panel,
  SourceBadge,
} from "@/components/dash/ui";
import { LeagueTableCard } from "@/components/dash/exec";

export default function LeaguesPage() {
  const q = useQuery({ queryKey: ["leagues"], queryFn: dashApi.leagues });

  return (
    <div className="space-y-6">
      <PageHeader
        title="League Tables"
        description="Branch and staff rankings with movement vs the previous period. Movement is computed from real historical snapshots."
      />
      {q.isLoading ? (
        <LoadingState />
      ) : q.isError ? (
        <ErrorState error={q.error} />
      ) : (
        <>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-400">Branch league</h2>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            {q.data?.branch.boards.map((b) => (
              <LeagueTableCard key={b.key} board={b} />
            ))}
          </div>

          <h2 className="pt-2 text-sm font-semibold uppercase tracking-wide text-slate-400">Staff league</h2>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
            {q.data?.staff.boards.map((b) => (
              <Panel key={b.key} title={b.label} right={<SourceBadge code={b.source} />}>
                <Leaderboard rows={b.rows} unit={b.unit} />
              </Panel>
            ))}
          </div>
          {q.data?.staff.gaps && <GapList gaps={q.data.staff.gaps} />}
        </>
      )}
    </div>
  );
}
